import axios from "../utils/axios-interceptor";

export const getUnitTestApi = async(payload) => {
  try {
    const res = await axios.post(`/unit-test/?github_link=${payload.repoPath}&language=${payload.language}`, {selected_model: payload.selected_model})
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}